// Singularize API-provided duration strings: "1 Days" -> "1 Day", "1 Hours" ->
// "1 Hour", while leaving "21 Days", "7 Days", etc. untouched (the \b before the
// digits won't match inside a multi-digit number like "21").
export const formatDuration = (str = "") =>
  String(str).replace(/\b(\d+) (Day|Hour)s\b/g, (m, n, unit) => (n === "1" ? `1 ${unit}` : m));

// Mirrors Core::calculateRent's RESET_TIME loop: start day + each hourly step that lands on the reset hour.
export const resetTimeBilledDays = (start, end, rate) => {
  const resetHour = parseInt(String(rate?.resetTime ?? "").slice(0, 2), 10);
  if (Number.isNaN(resetHour) || !start?.isValid?.() || !end?.isValid?.()) return null;
  const minEnd = start.add(Number(rate?.minHours) || 0, "hour");
  const stop = end.isBefore(minEnd) ? minEnd : end;
  let days = 1;
  for (let t = start; t.isBefore(stop); t = t.add(1, "hour")) {
    if (t.hour() === resetHour) days++;
  }
  if (start.hour() === resetHour) days--;
  return days;
};
